import React, { useEffect,useState,createRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import CustomSelect from '../../components/custom-select/CustomSelect';
import AlertDialog from '../../components/alert-dialog/AlertDialog';
import * as RestService from '../../services/eisRest';





  const WarehouseModal = (props) => {

   

    const [t] = useTranslation();      
    const [isOpen, setIsOpen] = useState(false);
    
    const [selectedRecord, setSelectedRecord] = useState();
   
    const [warehouse, setWarehouse] = useState([]);  
    const [itemTypeList, setItemTypeList] = useState([]);  
    const [itemType, setItemType] = useState(null);     
    const [openAlertDialog, setOpenAlertDialog] = useState(false);    
    const dialogRef = createRef();
  

  
  
    const hideModal = () => {
      setIsOpen(false);
      showChanged(false);
    };

    const showChanged = (newStatus) => {
      props.parentCallback(newStatus);
    }
    
    const deleteRecord = () => {
      setOpenAlertDialog(true);
    };

    useEffect(() => {
      formik.resetForm();
      setIsOpen(props.modal);
      showChanged(props.modal);

    }, [props.modal])

    
    useEffect(() => {      
      setSelectedRecord(props.selectedRecord);
      RestService.callAnyApi('warehouse/getWarehouse?id='+props.selectedRecord, null)
      .then((data) => {          
           setWarehouse(data);    
           setItemType(data.itemType);     
      })
      .catch((error) => {
        console.log(error);
      });

    }, [props.selectedRecord])

    const handleAlertDialogCallback = (clickedValue) => {
      setOpenAlertDialog(false);
      if(clickedValue==='OK'){
        RestService.callAnyApi('basic/deleteRecord?entity=warehouse&id='+props.selectedRecord, null).then(
          (data) => {
            hideModal();
          })
          .catch((error) => {
            console.log(error);
          });
      }
      
    }
    


    useEffect(() => {      
      RestService.callAnyApi('warehouse/getItemType', null).then((data) => {
        data.map(function(item,i){
          item.label = t('itemType.label.'+item.label);
        });
        
         setItemTypeList(data);  
      
        }).catch((error) => {});
   
    }, [])
    
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    const save = (url,values) => {
         
  //    warehouse.entityId=props.entityId;
    //  warehouse.bankId=values.bankId;
    //  warehouse.currency=values.currency;
    //  warehouse.departmentId=values.departmentId;
     // warehouse.iban=values.iban;
      warehouse.name = values.name
      warehouse.number = values.number;
      warehouse.itemType = values.itemType;
      warehouse.description = values.description;     
     
      RestService.callAnyApi(url, warehouse)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          toast.success(t('general.message.saveSucceed'));                                              
                          hideModal();
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    };

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {    

        name : warehouse.name,  
        number : warehouse.number,
        description : warehouse.description,
        itemType : warehouse.itemType
       // bankId: warehouse.bankId || "",
       // currency: warehouse.currency || "",
       // departmentId: warehouse.departmentId || "",
       // iban: warehouse.iban || "",
      },
      validationSchema: Yup.object({
      //   bankId: Yup.string()     
      //    .required(t('general.message.required')),
       //   currency: Yup.string()     
       //   .required(t('general.message.required')),
        //  iban: Yup.string()     
         // .required(t('general.message.required')),
      }),
      onSubmit: (values) => {           
          save('warehouse/saveWarehouse',values);         
      }
    });

    return (
      <>    
        <div className="modal-container">
                  <Modal
                    show={isOpen}
                    onHide={hideModal}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    centered
                    //size="lg"
                    ref={dialogRef}
                  >
                    <form onSubmit={formik.handleSubmit}>     
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title">{t('article.label.warehouse')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                                
                         <div className="row"> 
                                <div className="col-12">
                                  <div className="form-group">
                                    <label>{t('general.label.name')}</label>
                                    <input type="text" class="form-control" placeholder="" {...formik.getFieldProps('name')} />
                                  </div>
                                  {formik.touched.name && formik.errors.name ? (
                                    <div style={{ color: 'red' }}>{formik.errors.name}</div>
                                ) : null} 
                                </div>        
                          </div>

                          <div className="row">

                                <div className="col-6 col-sm-6 col-lg-6">
                                     <div className="form-group">
                                       <label>{t('article.label.number')}</label>
                                       <input type="text" className="form-control"  {...formik.getFieldProps('number')} />                                   
                                     </div>
                                </div>

                          </div>
                           
                          <div className="row">

                                  <div className="col-6 col-sm-6 col-lg-6">
                                        <div className="form-group">
                                          <label>{t('itemType.label.itemType')}</label>                               
                                          <CustomSelect
                                              className='input'
                                              name="itemType"
                                              onChange={(opt, e) => { 
                                                setItemType(opt.value);                                                                                           
                                                formik.setFieldValue('itemType', opt.value);
                                              }}
                                              value={itemType}
                                              options={itemTypeList}     
                                          />                                
                                        </div>  
                                        {formik.touched.itemType && formik.errors.itemType ? (<div style={{ color: 'red' }}>{formik.errors.itemType}</div>) : null}                            
                                      </div>   

                          </div>

                          <div className="row">
                               

                                <div className="col-12 col-sm-12 col-lg-12">
                                     <div className="form-group">
                                       <label>{t('general.label.description')}</label>
                                       <input type="text" className="form-control" {...formik.getFieldProps('description')} />                                   
                                     </div>
                                </div>
                          </div>
                           

                    </Modal.Body>
                    <Modal.Footer>                          
                          <Button style={selectedRecord ? {} : { display: 'none' }} className="btn-danger" onClick={deleteRecord}>{t('general.button.delete')}</Button>    
                          <Button className="btn-primary" type="submit">{t('general.button.save')}</Button>    
                          <Button className="btn-default" onClick={hideModal}>{t('general.button.cancel')}</Button>
                    </Modal.Footer>
                    </form>  
                                        
                  </Modal>                                      
                </div>
               
                <AlertDialog
                open={openAlertDialog}
                message={t('general.message.areYouSure')}
                header={t('general.message.confirmDelete')}
                parentCallback={handleAlertDialogCallback}
                ></AlertDialog> 

     
      </>
    );
  };

 export default WarehouseModal;